import React, { useCallback, useEffect,useRef, useState } from 'react'
import axios from "../../API/axios";
import { getUserConfig, getEmojiDDL } from "../../Services/apiService";
import { post, svg, people } from "../../config/imagesLink";
import AddPost from "./AddPost";
import PostInteractionModal from "./PostInteractionModal";
import { Link, useParams } from "react-router-dom";
import ImageSliderModal from "./ImageSliderModal";
import Loading from "../Blogs/Loading";
import moment from "moment";
import PostEngagement from "./PostEngagement";
import PostComment from "./PostComment";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import Comment from "./Comment";
import LikesDetails from "./LikesDetails";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { warning } from "framer-motion";
import { PostFeedSkeleton, ShimmerTitle, ImageWithLoader } from "@skeleton";
import PostComponent from "./PostComponent";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import Advertisement from "./PostAdvertisement";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import ThumbUpSharpIcon from '@mui/icons-material/ThumbUpSharp';
import ArrowLeftSharpIcon from '@mui/icons-material/ArrowLeftSharp';
import ArrowRightSharpIcon from '@mui/icons-material/ArrowRightSharp';
import RecommendationAction from "../Connections/RecommendationAction";
import CompanyInteraction from "../Companies/CompanyInteraction";
import PostVideoCommon from '../PersonalProfile/PostVideoCommon';
import { useTranslation } from 'react-i18next';
import useNewsFeedStore from './useNewsFeedStore';
import { mountAdSenseInContainer } from "../../utility/googleAds";

const { pin } = svg;

const HashTag = () => {
        const sessionId = localStorage.getItem("sessionId");
        const guestModeData = localStorage.getItem("guestMode");
        const { Hashtag } = useParams();
        const visibleVideoRef = useRef(null);
        const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
        const { t } = useTranslation();
            const language = localStorage.getItem("Lang");        
        const isDark = localStorage.getItem("isDark");
        const [toastMessage, setToastMessage] = useState("");
        const [showToast, setShowToast] = useState(false);
        const [isConnected, setIsConnected] = useState(false);
        const [postLikeState, setPostLikeState] = useState({});
        const ProfilePercent = localStorage.getItem("ProfilePercentage"); 
        const [warningToastMessage, setWarningToastMessage] = useState("");
        const [showWarningToast, setShowWarningToast] = useState(false);
    
        const [ErrorToastMessage, setErrorToastMessage] = useState("");
        const [showErrorToast, setShowErrorToast] = useState(false);
        const [activeVideoId, setActiveVideoId] = useState(null);
    
        const [postList, setPostList] = useState([]);
        const [loading, setLoading] = useState(false);
        const [isLoading, setIsLoading] = useState(true);
        const [page, setPage] = useState(1);
        const [totalPages, setTotalPages] = useState(1);
        const [totalRecord, setTotalRecord] = useState(1);
        const [isError, setIsError] = useState(false);
        const [restrictedViewerTokens, setRestrictedViewerToken] = useState('');
        
        const [dLike, setDLike] = useState(0);
    
        const userUid = localStorage.getItem("userUid");
        const [nextBatchLoading, setNextBatchLoading] = useState("");

          const adContainerRef = useRef(null);
          const adContainerRef1 = useRef(null);
        
          const refreshAds = () => {
            mountAdSenseInContainer(adContainerRef.current, {
              adSlot: "9135916775",
              style: "display: block; width: 100%; height: 400px; min-height: 400px; margin: 0 auto;",
            });
            mountAdSenseInContainer(adContainerRef1.current, {
              adSlot: "4907911040",
              style: "display: block; width: 100%; height: 400px; min-height: 400px; margin: 0 auto;",
            });
          };
        
          useEffect(() => {
            refreshAds(); // Initial ad render
          }, []);

          
        const AllPostList = async (page) => {
            const data = {
                deviceType: "Web",
                pageNumber: page,
                pageSize: 6,
                      langKey: language === "en" ? "" : language,

            };
            try {
                setLoading(true);
                setNextBatchLoading(true);
                const resData = await axios.post(`Feature/HashtagPosts?Hashtag=${Hashtag}`, data);
                setIsLoading(false);
    
                setTotalPages(resData.data.responseData.paging.totalPages);
                setTotalRecord(resData.data.responseData.paging.totalrecords);
                const newPosts = resData.data.responseData.dataList;
                 console.log("newPosts1111===>", newPosts);
     
                setPostList((prev) => {
                    const postSet = new Set(prev.map((post) => post.postInfo.postId));
                    const uniqueNewPosts = newPosts.filter((post) => !postSet.has(post.postInfo.postId));
                    setRestrictedViewerToken(resData?.data?.responseData?.restrictedViewerToken)

                    return [...prev, ...uniqueNewPosts];
                });
                if (page >= resData.data.responseData.paging.totalPages) {
                    setHasMoreData(false);
                }
                setNextBatchLoading(false);
    
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setIsError(true);
                } else {
                    console.error(error);
                }
                setIsLoading(false);
                setNextBatchLoading(false);
            }
        };

        const handleProfileImageError = (e) => {
            if (!e || !e.target) return;
            e.target.onerror = null;
            e.target.src = people.DefaultProfile;
        };
        const [hasMoreData, setHasMoreData] = useState(true);
        useEffect(() => {
    
            if (page <= totalPages) {
                AllPostList(page);
            }
        }, [page]);

        useEffect(() => {
            setPostLikeState((prev) => {
                const validPostIds = new Set(
                    postList
                        .map((post) => String(post?.postInfo?.postId || ""))
                        .filter(Boolean)
                );

                const filtered = Object.entries(prev).reduce((acc, [key, value]) => {
                    if (validPostIds.has(key)) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

                return Object.keys(filtered).length === Object.keys(prev).length
                    ? prev
                    : filtered;
            });
        }, [postList]);
    
    
        const getPostListWithAds = (posts) => {
            const result = [];
            posts.forEach((post, index) => {
                result.push(post);
                // Insert different components after every 12 posts
                if ((index + 1) % 6 === 0) {
                    const pageIndex = Math.floor((index + 1) / 6);
                    if (pageIndex % 2 === 1) {
                        result.push({ isAd: true });
                    } else if (pageIndex % 3 === 2) {
                        result.push({ isPeopleRecommendation: true });
                    } else if (pageIndex % 3 === 1) {
                        result.push({ isJobRecommendation: true });
                    } else if (pageIndex % 3 === 0) {
                        result.push({ isCompanyRecommendation: true });
                    }
                }
            });
            return result;
        };
        const postsWithAds = getPostListWithAds(postList);
    
        const handleInfiniteScroll = async () => {
            try {
                if (
                    window.innerHeight + document.documentElement.scrollTop + 1 >=
                    document.documentElement.scrollHeight
                ) {
                    setLoading(true);
                    setPage((prev) => prev + 1);
                }
            } catch (error) {
                console.error(error);
            }
        };
    
        useEffect(() => {
            window.addEventListener("scroll", handleInfiniteScroll);
            return () => window.removeEventListener("scroll", handleInfiniteScroll);
        }, []);
    
        const updateLikeCount = (postId, delta, isLikedStatus, likedType) => {
            setPostList((prev) =>
                prev.map((post) =>
                    post.postInfo.postId === postId
                        ? {
                            ...post,
                            postInfo: {
                                ...post.postInfo,
                                likeCount: Math.max((post.postInfo.likeCount || 0) + delta, 0),
                                postActionsInfo: {
                                    ...post.postInfo.postActionsInfo,
                                    ...(typeof isLikedStatus === "boolean"
                                        ? { isLiked: isLikedStatus }
                                        : {}),
                                    ...(likedType !== undefined ? { likedType: likedType } : {}),
                                },
                            },
                        }
                        : post
                )
            );

            if (typeof isLikedStatus === "boolean") {
                setPostLikeState((prev) => ({
                    ...prev,
                    [String(postId)]: isLikedStatus,
                }));
            }
        };
    
    
        const updateCommentCount = (postId, change) => {
            setPostList((prev) =>
                prev.map((post) =>
                    post?.postInfo?.postId === postId
                        ? {
                            ...post,
                            postInfo: {
                                ...post.postInfo,
                                commentCount: Math.max((post?.postInfo?.commentCount || 0) + change, 0),
                            },
                        }
                        : post
                )
            );
        };
    
        const updateShareCount = (postId, change) => {
            setPostList((prev) =>
                prev.map((post) =>
                    post?.postInfo?.postId === postId
                        ? {
                            ...post,
                            postInfo: {
                                ...post.postInfo,
                                shareCount: Math.max((post?.postInfo?.shareCount || 0) + change, 0),
                            },
                        }
                        : post
                )
            );
        };

        const updateCommentLike = (postId, commentId, action, likeType = null) => {
            setPostList((prevList) =>
                prevList.map((item) => {
                    if (item?.postInfo?.postId !== postId) return item;

                    return {
                        ...item,
                        postInfo: {
                            ...item.postInfo,
                            comments: (item.postInfo.comments || []).map((c) => {
                                if (c.pstCmntId !== commentId) return c;

                                if (action === "like") {
                                    return {
                                        ...c,
                                        likeCount: (c.likeCount || 0) + 1,
                                        isLiked: true,
                                        likedType: likeType,
                                    };
                                }

                                if (action === "unlike") {
                                    return {
                                        ...c,
                                        likeCount: Math.max((c.likeCount || 1) - 1, 0),
                                        isLiked: false,
                                        likedType: null,
                                    };
                                }

                                if (action === "change") {
                                    return {
                                        ...c,
                                        isLiked: true,
                                        likedType: likeType,
                                    };
                                }

                                return c;
                            }),
                        },
                    };
                })
            );
        };

        const updateReplyCommentLike = (postId, commentId, replyId, action, likeType = null) => {
            setPostList((prevList) =>
                prevList.map((post) => {
                    if (post?.postInfo?.postId !== postId) return post;

                    return {
                        ...post,
                        postInfo: {
                            ...post.postInfo,
                            comments: (post.postInfo.comments || []).map((c) => {
                                if (c.pstCmntId !== commentId) return c;

                                return {
                                    ...c,
                                    commentsReplies: (c.commentsReplies || []).map((reply) => {
                                        if (reply.pstCmntRplyId !== replyId) return reply;

                                        if (action === "like") {
                                            return {
                                                ...reply,
                                                isLiked: true,
                                                likeCount: (reply.likeCount || 0) + 1,
                                                likedType: likeType,
                                            };
                                        }

                                        if (action === "unlike") {
                                            return {
                                                ...reply,
                                                isLiked: false,
                                                likeCount: reply.likeCount > 0 ? reply.likeCount - 1 : 0,
                                                likedType: null,
                                            };
                                        }

                                        if (action === "change") {
                                            return {
                                                ...reply,
                                                isLiked: true,
                                                likedType: likeType,
                                            };
                                        }

                                        return reply;
                                    }),
                                };
                            }),
                        },
                    };
                })
            );
        };
    
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [modalImages, setModalImages] = useState([]);
        const [singlePostContent, setSinglePostContent] = useState("");
        const [singlepostId, setSinglePostId] = useState("");
        const [ispostmodalOpen, setIspostmodalOpen] = useState(false);
    
        const [sliderSettings, setSliderSettings] = useState({
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
        });
    
        const [mediaFiles, setMediaFiles] = useState([]);

        const mergePostData = useCallback((existingPost, incomingPostData, incomingComments = null) => {
            if (!incomingPostData) return existingPost;

            if (incomingPostData?.postInfo) {
                return {
                    ...existingPost,
                    ...incomingPostData,
                    postInfo: {
                        ...existingPost?.postInfo,
                        ...incomingPostData.postInfo,
                        comments: Array.isArray(incomingComments)
                            ? incomingComments
                            : Array.isArray(incomingPostData?.postInfo?.comments)
                                ? incomingPostData.postInfo.comments
                                : existingPost?.postInfo?.comments || [],
                    },
                };
            }

            return {
                ...existingPost,
                postInfo: {
                    ...existingPost?.postInfo,
                    ...incomingPostData,
                    comments: Array.isArray(incomingComments)
                        ? incomingComments
                        : Array.isArray(incomingPostData?.comments)
                            ? incomingPostData.comments
                            : existingPost?.postInfo?.comments || [],
                },
            };
        }, []);

        const syncPostInFeed = useCallback(async (postIdToSync) => {
            if (!postIdToSync) return;

            try {
                const response = await axios.get(
                    `/Posts/GetPostInfo?DeviceType=Web&PostId=${postIdToSync}&RestrictedViewerToken=${restrictedViewerToken || restrictedViewerTokens || ""}&langKey=${language === "en" ? "" : language}`
                );

                const latestPostData = response?.data?.responseData?.postInfo;
                if (!latestPostData) return;

                if (typeof latestPostData?.postActionsInfo?.isLiked === "boolean") {
                    setPostLikeState((prev) => ({
                        ...prev,
                        [String(postIdToSync)]: latestPostData.postActionsInfo.isLiked,
                    }));
                }

                setPostList((prevList) =>
                    prevList.map((post) =>
                        post?.postInfo?.postId === postIdToSync
                            ? mergePostData(post, latestPostData)
                            : post
                    )
                );
            } catch (error) {
                console.error("Failed to sync hashtag post data after modal close:", error);
            }
        }, [language, restrictedViewerToken, restrictedViewerTokens, mergePostData]);

        const openModal = (mediaFiles, initialSlide) => {
            
            setIsLoading(true);
            console.log("openModal..........")
            setSliderSettings((prevSettings) => ({
                ...prevSettings,
                initialSlide: initialSlide,
            }));
            setMediaFiles(mediaFiles);
            setIsModalOpen(true);

            
        };
        
    
        const closeModal = (closePayload = singlepostId) => {
            const isPayloadObject = typeof closePayload === "object" && closePayload !== null;

            const postIdToSync = isPayloadObject
                ? closePayload?.postId ?? singlepostId
                : closePayload;

            const modalPostSnapshot = isPayloadObject ? closePayload?.postSnapshot : null;
            const modalCommentsSnapshot = isPayloadObject ? closePayload?.commentsSnapshot : null;

            setIsModalOpen(false);
            setIspostmodalOpen(false);

            if (postIdToSync && modalPostSnapshot) {
                const modalLikedState =
                    modalPostSnapshot?.postInfo?.postActionsInfo?.isLiked ??
                    modalPostSnapshot?.postActionsInfo?.isLiked;

                if (typeof modalLikedState === "boolean") {
                    setPostLikeState((prev) => ({
                        ...prev,
                        [String(postIdToSync)]: modalLikedState,
                    }));
                }

                setPostList((prevList) =>
                    prevList.map((post) =>
                        post?.postInfo?.postId === postIdToSync
                            ? mergePostData(post, modalPostSnapshot, modalCommentsSnapshot)
                            : post
                    )
                );
            }

            setTimeout(() => {
                syncPostInFeed(postIdToSync);
            }, 350);
        };
    
        const [isfollowed, setIsfollowed] = useState(false);
    
        const [emojiList, setemojiList] = useState();
        const GetEmoji = async () => {
            try {
                const responseData = await getEmojiDDL(language);
                setemojiList(responseData);
            } catch (error) {
                console.log(error);
            }
        };
        useEffect(() => {
            GetEmoji();
        }, []);
    
        const [showModal, setShowModal] = useState(false);
        const [postLikedType, setPostLikedType] = useState(false);
        const [postId, setPostId] = useState("");
        const [initialSlideIndex, setInitialSlideIndex] = useState(0);
        const [imageArray, setImageArray] = useState([]);
    
        const handleShowModal = (item) => {
            setPostId(item?.postInfo?.postId);
            setPostLikedType(item?.postInfo?.postActionsInfo?.likedType);
            setShowModal(true);
        };
        const handleLikesCloseModal = () => {
            setShowModal(false);
        };
    
    
        useEffect(() => {
            const scrollToTop = () => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            };
            scrollToTop();
        }, []);
    
        const [showDeletePost, setShowDeletePost] = useState(false)
    
        useEffect(() => {
            if (isModalOpen || showDeletePost) {
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';
                document.body.classList.add('modal-open'); // When a modal opens
            } else {
                document.body.style.overflow = 'unset';
                document.documentElement.style.overflow = '';
                document.body.classList.remove('modal-open'); // When a modal closes
            }
        }, [isModalOpen, showDeletePost])
        // const [userPer, setUserPer] = useState([]);
        const [alert, setAlert] = useState(false);
        const [isLoadingalert, setIsLoadingalert] = useState(true); // Add loading state
    
        // const getUserProfilePer = () => {
        //     const data = {
        //         deviceType: "Web",
        //         sessionId: sessionId,
        //     };
        //     axios
        //         .post(`UserProfile/GetProfilePercentage`, data)
        //         .then((response) => {
        //             const res = response.data.responseData;
        //             setUserPer(res.percentage);
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //         })
        //         .finally(() => {
        //             setIsLoadingalert(false); // Set loading to false once the data is fetched
        //         });
        // };
    
        // useEffect(() => {
        //     getUserProfilePer();
        // }, [sessionId]);
    
        const [pr, setPR] = useState([])
        const [jr, setJR] = useState([])
        const [cr, setCR] = useState([])
    
    
        const scrollRef = useRef(null);
    
        const scroll = (direction) => {
            if (scrollRef.current) {
                const scrollAmount = 300; // Adjust scroll distance as needed
                scrollRef.current.scrollBy({
                    left: direction === "left" ? -scrollAmount : scrollAmount,
                    behavior: "smooth",
                });
            }
        };
        const scrollRef1 = useRef(null);
    
        const scroll1 = (direction) => {
            if (scrollRef1.current) {
                const scrollAmount = 300; // Adjust scroll distance as needed
                scrollRef1.current.scrollBy({
                    left: direction === "left" ? -scrollAmount : scrollAmount,
                    behavior: "smooth",
                });
            }
        };
        const scrollRef2 = useRef(null);
    
        const scroll2 = (direction) => {
            if (scrollRef2.current) {
                const scrollAmount = 300; // Adjust scroll distance as needed
                scrollRef2.current.scrollBy({
                    left: direction === "left" ? -scrollAmount : scrollAmount,
                    behavior: "smooth",
                });
            }
        };
        const [recommendationList, setRecommendationList] = useState([]);
        const [showDropdown, setShowDropdown] = useState(false);
        const handleToggleDropdown = (index) => {
            setShowDropdown((prev) => (prev === index ? null : index));
        };
        const [followedCompanies, setFollowedCompanies] = useState({});
        // const [checkApplied, setCheckApplied] = useState(isAppliedByYou);
        const [bookmarkModal, setBookmarkModal] = useState(false);
        const [showAppliedModal, setShowAppliedModal] = useState(false);
        const handleShow = () => setShowAppliedModal(true);
        const handleCloseModal = () => setShowAppliedModal(false);
        const closeModalData = () => {
            setBookmarkModal(false);
        };
        const applyNew = async (jobId) => {
            try {
                const body = {
                    deviceType: "Web",
                    sessionId: sessionId,
                    jobId: jobId,
                    type: 1,
                    userUid: userUid,
                          langKey: language === "en" ? "" : language,

                };
                const res = await axios.post("/JobAction/ApplyJob", body);
                setToastMessage(res.data.message);
                setShowToast(true);
                // getJobRecommendation()
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    setWarningToastMessage(e.response.data.message);
                    setShowWarningToast(true);
                } else {
                    setErrorToastMessage(e.response.message);
                    setShowErrorToast(true);
                }
            }
        };
     
        const [showResumeModal, setShowResumeModal] = useState(false);
        const [unauthorisedModal, setUnauthorisedModal] = useState(false);
        const userConfig = async () => {
            try {
                const responseData = await getUserConfig();
                setProfileConfig(responseData);
            } catch (error) {
                if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
                    setUnauthorisedModal(true)
                }
            }
        };
        const [profileConfig, setProfileConfig] = useState([]);
        useEffect(() => {
            userConfig();
        }, []);
    
        //************************Save job End  ************************//
        const [savedJobs, setSavedJobs] = useState(new Set());
        const saveJob = async (jobId) => {
            const responseData = {
                deviceType: "Web",
                sessionId: sessionId,
                jobId: jobId,
                      langKey: language === "en" ? "" : language,

            };
            try {
                await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
                    console.log("save post", res);
                    setToastMessage(res.data.message);
                    setShowToast(true);
                    setSavedJobs((prev) => new Set(prev).add(jobId));
                });
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    setWarningToastMessage(e.response.data.message);
                    setShowWarningToast(true);
                } else {
                    setErrorToastMessage(e.response.data.message);
                    setShowErrorToast(true);
                }
            }
        };
    
        //************************Save job End  ************************//
    
        //************************UnSave job start  ************************//
        const unsaveJob = async (jobId) => {
            const responseData = {
                deviceType: "Web",
                sessionId: sessionId,
                jobId: jobId,
                langKey: language === "en" ? "" : language,
            };
            try {
                await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
                    // console.log(res);
                    // toast.success(res.data.message);
                    setToastMessage(res.data.message);
                    setShowToast(true);
                    // AllJobList();
                    // setIsSaved(false);
                    setSavedJobs((prev) => {
                        const newSavedJobs = new Set(prev);
                        newSavedJobs.delete(jobId);
                        return newSavedJobs;
                    });
                });
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    setWarningToastMessage(e.response.data.message);
                    setShowWarningToast(true);
                } else {
                    setErrorToastMessage(e.response.data.message);
                    setShowErrorToast(true);
                }
            }
        };
    
        //************************UnSave job End  ************************//
    
        const updatePostLike = (postId, delta, isLikedStatus, likedType) => {
    setPostList((prev) =>
      prev.map((post) => {
        if (post.postInfo.postId === postId) {
          // const newLikeCount = Math.max(0, post.postInfo.likeCount + delta);

          return {
            ...post,
            postInfo: {
              ...post.postInfo,
              // likeCount: newLikeCount,
              postActionsInfo: {
                ...post.postInfo.postActionsInfo,
                isLiked: isLikedStatus,
                likedType: likedType,
              },
            },
          };
        }
        return post;
      })
    );

        if (typeof isLikedStatus === "boolean") {
            setPostLikeState((prev) => ({
                ...prev,
                [String(postId)]: isLikedStatus,
            }));
        }
  };

        const currentModalPost = postList.find(
            (post) => String(post?.postInfo?.postId) === String(singlepostId)
        );

        const modalIsLiked = Boolean(
            postLikeState[String(singlepostId)] ?? currentModalPost?.postInfo?.postActionsInfo?.isLiked
        );

        const handleModalSetIsLiked = (likedValue) => {
            const modalPostId = singlepostId || currentModalPost?.postInfo?.postId;
            if (!modalPostId) return;

            const nextLiked = Boolean(likedValue);

            setPostLikeState((prev) => ({
                ...prev,
                [String(modalPostId)]: nextLiked,
            }));

            setPostList((prevList) =>
                prevList.map((post) =>
                    String(post?.postInfo?.postId) === String(modalPostId)
                        ? {
                            ...post,
                            postInfo: {
                                ...post.postInfo,
                                postActionsInfo: {
                                    ...post?.postInfo?.postActionsInfo,
                                    isLiked: nextLiked,
                                },
                            },
                        }
                        : post
                )
            );
        };
        console.log("postsWithAds", postsWithAds);

         // -------------------------------------------------------------------------
          const { setIsNewsPageLoaded } = useNewsFeedStore();
        
          useEffect(() => {
            setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed
        
            return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
          }, [setIsNewsPageLoaded]);
        
          // -------------------------------------------------------------------------
        
        
  return (
   <>
            <div className="row mt-3">
                   <div className="col-md-8 newsfeedPosts"   >
   
                       <div className="sticky-top d-flex featured-card p-3 mb-3 justify-content-between" style={{top:'75px', zIndex:'1'}}>
                         <div className="d-flex align-items-center space-x-2">
                             <h6 className="f-600 mb-0"># {Hashtag} |</h6>
                              <span className="label f-14 ms-2">
                                {isLoading? 
                                     (<div className="shimmer-title ms-3 mb-0">
                                           <ShimmerTitle line={1} />
                                       </div>)
                                       : 
                                       <>
                                        {totalRecord} Post
                                       </>
                                       }
                                 </span>
                           </div>
                                {/* <div className="flex align-items-center label">
                                 <div className="flex align-items-center f-14 me-2 ">
                                  <PersonOutlineOutlinedIcon className=' '/>
                                    <span>15</span>
                                 </div>
                                 <StarBorderOutlinedIcon className='me-1' />
                                  <SettingsOutlinedIcon className='me-1'/>
                                </div> */}
                            </div>


                       {isLoading ? (
                           <PostFeedSkeleton count={2} />
                       ) : isError ? (
                           <div className="mt-2 error-image-cont">
                               <img src={post.errorbig} alt="404 Not Found" />
                           </div>
                       ) : (
                           <>
                               {postsWithAds.filter((item) => !item.isHidden).map((item, index) => {
                                               console.log("resData", item);
   
                                   return (
                                       <React.Fragment key={`post-${index}`}>
                                        
                                           {item.isAd && <Advertisement key={`ad-${index}`} />}
                           
                                           {!item.isAd && 
                                           !item.isPeopleRecommendation && 
                                           !item.isJobRecommendation && 
                                           !item.isCompanyRecommendation && (
                                             <div>
                                                
                                               <div
                                                   className="featured-card user-postOnlyContent p-2 mb-3 "
                                                   key={index}
                                               >
                                                   {item?.isSuggested === true && (
                                                       <div className={`postData d-flex align-items-center border-custom1 `}>
                                                           <div className="thumb">
                                                               <ThumbUpSharpIcon />
                                                           </div>
                                                           <div className="ms-2">
                                                               <p className=" gradient-text">
                                                                 {t("Newsfeed.Suggested based on your network")}
                                                               </p>
                                                           </div>
                                                       </div>
                                                   )}
                                                   {/* {item?.contentInfo === null ? "" : (
                                                   <div className={`postData d-flex align-items-center border-custom1 `}>
                                                       <div className="circle-container">
                                                           {item?.contentInfo?.pics?.map((pic, idx) => (
                                                               <>
                                                                   <img
                                                                       src={pic}
                                                                       alt={`Circle ${idx + 1}`}
                                                                       className="circle-img borderCircle"
                                                                       key={idx}
                                                                   />
                                                               </>
                                                           )
                                                           )}
                                                       </div>
                                                       <div style={{ marginLeft: item?.contentInfo?.count === 3 ? "32px" : "10px" }}>
                                                           <p
                                                               className="f-12"
                                                           >
                                                               {item?.contentInfo?.text}
                                                           </p>
                                                       </div>
                                                   </div>
                                                   )} */}
                                                    {item?.contentInfo === null ? (
                              ""
                            ) : (
                              <div
                                className={`postData d-flex align-items-center border-custom1 `}
                                 style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",  
                              }}
                              >
                                <div className="circle-container"  style={{
                                  marginLeft: language === "ar" ? "10px" : "initial",
                                }}
                                >
                                  {item?.contentInfo?.pics?.map((pic, idx) => (
                                    <>
                                      <img
                                        src={pic || people.DefaultProfile}
                                        alt=""
                                        className="circle-img borderCircle"
                                        key={idx}
                                        onError={handleProfileImageError}
                                      />
                                    </>
                                  ))}
                                </div>
                                <div
                                 style={{
                                    
                                    marginLeft:
                                      item?.contentInfo?.count === 3
                                        ? "3px"
                                        : "10px",
                                  }}
                                >
                                  <p className="f-12" >
                                    {item?.contentInfo?.text} 
                                    {/* {language === "ar" ? (
                                    item?.contentInfo?.count > 3 ? 
                                    (` ${t("SignIn.And")} ${item?.contentInfo?.count - 2} ${item?.contentInfo?.contentInfoType 
                                      // > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType
                                     }`) :
                                    (`${item?.contentInfo?.contentInfoType
                                      //  > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType 
                                      }`)
                                     
                                    
                                    ): (
                                    item?.contentInfo?.count > 3 ? 
                                    (`${t("SignIn.And")} ${item?.contentInfo?.count - 2} ${t("SignIn.others")} 
                                    ${item?.contentInfo?.contentInfoType 
                                      // > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType
                                     }`) :
                                    (`${item?.contentInfo?.contentInfoType
                                      //  > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType 
                                      }`)
                                     
                                    
                                    )} */}
                                    
                                  </p>
                                </div>
                              </div>
                            )}
                                                   <div className="feature-content p-2 d-flex justify-content-between">
                                                       <Link
                                                           to={
                                                               item?.postInfo?.postOriginType === "Company"
                                                                   ? `/Company/${item?.postInfo?.userUid}`
                                                                   : `/User/${item?.postInfo?.userUid}`
                                                           }
                                                       >
                                                           <div className="d-flex align-items-center">
                                                               <div className="ImgAvatar">
                                                                   <img
                                                                       src={item?.postInfo?.userAvatar || people.DefaultProfile}
                                                                       alt=""
                                                                       style={{ borderRadius: "50px" }}
                                                                       onError={handleProfileImageError}
                                                                   />
                                                               </div>
   
                                                               <div className="ms-2">
                                                                   <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName} </h4>
                                                                   <p className="f-12">{item?.postInfo?.title}</p>
                                                                   <p className="f-12">{item?.postInfo?.additionalInfo}</p>
                                                                   <p className="f-10 label">
                                                                       {moment
                                                                           .utc(item?.postInfo?.creationTime)
                                                                           .local()
                                                                           .format("DD MMMM YYYY [at] h:mm a")}
                                                                   </p>
                                                               </div>
                                                           </div>
                                                       </Link>
   
                                                       {guestModeData === "true" ? (
                                                           ""
                                                       ) : (
                                                           <div className="row">
                                                               <div>
                                                                   <PostInteractionModal
                                                                       postId={item?.postInfo?.postId}
                                                                       AllPostList={AllPostList}
                                                                       postList={postList}
                                                                       setPage={setPage}
                                                                       setPostList={setPostList}
                                                                       page={page}
                                                                       setTotalPages={setTotalPages}
                                                                       totalPages={totalPages}
                                                                       item={item}
                                                                       restrictedViewerToken={restrictedViewerToken}
                                                                       PostOriginType={"User"}
                                                                       postOriginId={userUid}
                                                                       setIsConnected={setIsConnected}
                                                                       isConnected={isConnected}
                                                                       isfollowed={isfollowed}
                                                                       setIsfollowed={setIsfollowed}
                                                                       setShowDeletePost={setShowDeletePost}
                                                                       showDeletePost={showDeletePost}
                                                                       ispinned={item?.postInfo?.postActionsInfo?.isPinned}
                                                                   />
                                                               </div>
                                                           </div>
                                                       )}
                                                   </div> 
                                                    {item.cntntTypCategory==='Article' || item.contentType==='ArticlePost' ? 
                                                        <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.articleInfo?.title}</h4>
                                                             : 
                                                           <>
                                                          <PostComponent item={item} />
                                                         </>
                                                      }
                                                   
   
                                                   <div
                                                       className="feed-post"
                                                       style={{
                                                           paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                                                       }}
                                                   >
   
                                                       <div className="row">
                                                           
                                                           {item?.postInfo.mediaFilesList?.slice(0, 4).map((file, idx) => (
                                                       
                                                               <div
                                                                   key={idx}
                                                                   className={`col-${item?.postInfo.mediaFilesList.length === 1 ? "12" : "6"
                                                                       } ${item?.postInfo.mediaFilesList.length === 3 && idx === 0
                                                                           ? "col-12"
                                                                           : ""
                                                                       }`}
                                                                   onClick={() => {
                                                                       setInitialSlideIndex(idx);
                                                                       setImageArray(item?.postInfo.mediaFilesList); 
                                                                       let imageData = item?.postInfo.mediaFilesList.map(
                                                                           (file) => file.mediaName
                                                                       );
                                                                        
                                                                    //    openModal(imageData, idx);
                                                                    (item?.cntntTypCategory === 'UserStory' || item?.cntntTypCategory === 'Text' 
                                                                        || item.cntntTypCategory=== 'Image'  ) 
                                                                        && openModal(imageData, idx);
                                                                        if (
                                                                            item?.cntntTypCategory === 'Article' ||
                                                                            item?.contentType === 'ArticlePost'
                                                                        ) { 
                                                                            window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank'); 
                                                                        }
                                                                       setSinglePostContent(item.postInfo);
                                                                       setSinglePostId(item?.postInfo?.postId);
                                                                   }}
                                                                   style={{
                                                                       position: "relative",
                                                                       cursor: "pointer",
                                                                       padding:
                                                                           item?.postInfo.mediaFilesList.length === 3 && idx === 0
                                                                               ? "0 0 5px 0"
                                                                               : item?.postInfo.mediaFilesList.length === 3 && idx === 1
                                                                                   ? "0 5px 5px 0"
                                                                                   : item?.postInfo.mediaFilesList.length === 4 && idx === 2
                                                                                       ? "0 5px 0 0"
                                                                                       : item?.postInfo.mediaFilesList.length === 4 && idx === 0
                                                                                           ? "0 5px 5px 0"
                                                                                           : item?.postInfo.mediaFilesList.length === 2 && idx === 0
                                                                                               ? "0 5px 5px 0"
                                                                                               : "",
                                                                   }}
                                                               >
                                                                   
                                                                    {item?.cntntTypCategory !== 'TextWithVideo' && item?.cntntTypCategory !== 'Video' ? (
                                                                    <ImageWithLoader
                                                                    src={file?.mediaName}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                    width={"100%"}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = post.noimgavailable;
                                                                    }}
                                                                    />
                                                                    ) : null}
                                                                    {item?.cntntTypCategory === 'TextWithVideo' || item?.cntntTypCategory === 'Video' ? 
                                                                    <div className="newsfeed-video">

                                                                    {/* <iframe width="100%" height="300" 
                                                                    src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
                                                                    ></iframe> */}
                                                                    {/* <PostVideoCommon file={file} 
                                                                    item={item} 
                                                                    restrictedViewerToken={restrictedViewerToken} 
                                                                    setActiveVideoId={setActiveVideoId}  
                                                                    activeVideoId={activeVideoId}/>
                                                                    
                                                                    </div> : null} */}

                                                                    <PostVideoCommon file={file} 
                                                                    item={item}
                                                                       restrictedViewerToken={restrictedViewerToken}
                                                                       setActiveVideoId={setActiveVideoId}
                                                                       activeVideoId={activeVideoId}
                                                                       AllPostList={AllPostList}
                                                                       setPostList={setPostList}
                                                                       visibleVideoRef={visibleVideoRef} />
                                                                   </div> : null}                                           

                                                                   {idx === 3 && item?.postInfo.postMediaCount > 4 && (
                                                                       <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                                           +{item?.postInfo.postMediaCount - 4}
                                                                       </div>
                                                                   )}
                                                               </div>
                                                           ))}
                                                       </div>
                                                       {guestModeData === "true" ? (
                                                           ""
                                                       ) : (

                                                          
                                                         <> 
                                                        
                                                                                        {item.cntntTypCategory==='Article' || item.contentType==='ArticlePost' ? 
                                                                                         
                                                                                         <div className="row comment-gradient-article">  
                                                                                          <PostComponent item={item} />                                                          
                                                                                            <div
                                                                                                className="addComment"
                                                                                                onClick={() => {
                                                                                                    setInitialSlideIndex(1);
                                                                                                    setImageArray(item?.postInfo?.mediaFilesList); 
                                                                                                    if (Array.isArray(item?.postInfo?.mediaFilesList)) {
                                                                                                        openModal(item?.postInfo?.mediaFilesList.map((file) => file.mediaName));
                                                                                                    } else {
                                                                                                        openModal([]); // Fallback to an empty array
                                                                                                    }
                                                                                                    //    openModal(imageData, 1);
                                                                                                    setSinglePostContent(item.postInfo);
                                                                                                    setSinglePostId(item?.postInfo?.postId);
                                                                                                }}
                                                                                            >
                                                                                                <div
                                                                                                    className="postCommentWrapper"
                                                                                                    onClick={(event) => event.stopPropagation()}
                                                                                                >
                                                                                                    <PostComment
                                                                                                        item={item}
                                                                                                        postId={item?.postInfo?.postId}
                                                                                                        AllPostList={AllPostList}
                                                                                                        postList={postList}
                                                                                                        setPage={setPage}
                                                                                                        setPostList={setPostList}
                                                                                                        page={page}
                                                                                                        setTotalPages={setTotalPages}
                                                                                                        totalPages={totalPages}
                                                                                                        updateCommentCount={updateCommentCount}
                                                                                                        ispostmodalOpen={ispostmodalOpen}
                                                                                                        setIspostmodalOpen={setIspostmodalOpen}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                           </div>
                                                                                                  
                                                                                          : (
                                                                                            <div className="row comment-gradient">                                                           
                                                                                            <div
                                                                                                className="addComment"
                                                                                                onClick={() => {
                                                                                                    setInitialSlideIndex(1);
                                                                                                    setImageArray(item?.postInfo?.mediaFilesList); 
                                                                                                    if (Array.isArray(item?.postInfo?.mediaFilesList)) {
                                                                                                        openModal(item?.postInfo?.mediaFilesList.map((file) => file.mediaName));
                                                                                                    } else {
                                                                                                        openModal([]); // Fallback to an empty array
                                                                                                    }
                                                                                                    //    openModal(imageData, 1);
                                                                                                    setSinglePostContent(item.postInfo);
                                                                                                    setSinglePostId(item?.postInfo?.postId);
                                                                                                }}
                                                                                            >
                                                                                                <div
                                                                                                    className="postCommentWrapper"
                                                                                                    onClick={(event) => event.stopPropagation()}
                                                                                                >
                                                                                                    <PostComment
                                                                                                        item={item}
                                                                                                        postId={item?.postInfo?.postId}
                                                                                                        AllPostList={AllPostList}
                                                                                                        postList={postList}
                                                                                                        setPage={setPage}
                                                                                                        setPostList={setPostList}
                                                                                                        page={page}
                                                                                                        setTotalPages={setTotalPages}
                                                                                                        totalPages={totalPages}
                                                                                                        updateCommentCount={updateCommentCount}
                                                                                                        ispostmodalOpen={ispostmodalOpen}
                                                                                                        setIspostmodalOpen={setIspostmodalOpen}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                           </div>
                                                        
                                                                                          )}
                                                        
                                                                                        </>
                                                       )}
                                                   </div>
   
                         <div
                              className={`postData d-flex align-items-center justify-content-between ${item?.postInfo?.likeCount === 0 &&
                                item?.postInfo?.commentCount === 0 &&
                                item?.postInfo?.shareCount === 0
                                ? ""
                                : "border-custom1"
                                }`}
                              style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",  
                              }}
                                
                            >
                           {language === "ar" ? (
                              <div className="d-flex">
                                
                                <div className="d-flex"
                                  style={{
                                  marginLeft:
                                      item?.contentInfo?.count === 3
                                        ? "12px"
                                        : "10px",
                                  }}
                                >
                                  {item?.postInfo?.likeCount === 0 || item?.postInfo?.likeCount === null ? (
                                    ""
                                    ) : (
                                    <>
                                        <p
                                            className="f-10 me-2 ms-2 pointer d-flex like-details"
                                            onClick={() => handleShowModal(item)}
                                          > 
                                            {item?.postInfo?.likeCount} <ThumbUpOutlinedIcon  style={{color:"#00419f", fontSize: "13px"}}/>
                                             

                                            </p>
                                             <div className="circle-container">
                                                {item?.postInfo?.postReactionContent?.pics?.map(
                                                  (pic, idx) => (
                                                    <>
                                                      <img
                                                        src={pic || people.DefaultProfile}
                                                        alt=""
                                                        className="circle-img borderCircle"
                                                        key={idx}
                                                        onError={handleProfileImageError}
                                                      />
                                                    </>
                                                  )
                                                )}
                                              </div>
                                            <p className="f-10 me-2 pointer d-flex">
                                            {item?.postInfo?.postReactionContent === null
                                              ? ""
                                              : ` ${item?.postInfo?.postReactionContent?.text}`
                                            } {item?.postInfo?.likeCount > 3 && (
                                              ` ${t("SignIn.And")} ${
                                                item?.postInfo?.postReactionContent?.count - 2
                                              } ${item?.postInfo?.postReactionContent?.contentInfoType
                                              }`
                                                ) 
                                            }
                                          
                                          </p>
                                    </>

                                  )}
                                </div>
                              </div>
                           ) : (
                            <div className="d-flex align-items-center">
                               
                                <div 
                                  style={{
                                  marginLeft:
                                      item?.contentInfo?.count === 3
                                        ? "12px"
                                        : "10px",
                                  }}
                                  className="d-flex align-items-center "
                                >
                                  {item?.postInfo?.likeCount === 0 || item?.postInfo?.likeCount === null ? (
                                    ""
                                    ) : (
                                    <>
                                        <p
                                            className="f-10 me-1 pointer d-flex like-details"
                                            onClick={() => handleShowModal(item)}
                                          > 
                                            {item?.postInfo?.likeCount} <ThumbUpOutlinedIcon   style={{color:"#00419f", fontSize: "13px"}}/>
                                             
                                            </p>
                                            <div className="circle-container">
                                                {item?.postInfo?.postReactionContent?.pics?.map(
                                                  (pic, idx) => (
                                                    <>
                                                      <img
                                                        src={pic || people.DefaultProfile}
                                                        alt=""
                                                        className="circle-img borderCircle"
                                                        key={idx}
                                                        onError={handleProfileImageError}
                                                      />
                                                    </>
                                                  )
                                                )}
                                              </div>
                                              {/* <p className="f-10 me-2 ms-1 pointer">
                                            {item?.postInfo?.postReactionContent === null
                                              ? ""
                                              : ` ${item?.postInfo?.postReactionContent?.text}`
                                            } { 
                                              item?.postInfo?.likeCount > 3 && (
                                              ` ${t("SignIn.And")} ${
                                                item?.postInfo?.postReactionContent?.count - 2
                                              } ${t("SignIn.others")} ${
                                                item?.postInfo?.postReactionContent?.contentInfoType
                                              }`
                                            ) 
                                            }
                                          
                                          </p> */}
                                    </>

                                  )}
                                </div>
                              </div>
                           )}


                               <div className="d-flex HuzCommentIconWidth">
                                {item?.postInfo?.commentCount === 0 || item?.postInfo?.commentCount === null ? (
                                  ""
                                ) : (
                                  <p
                                    className="f-10 me-2 pointer"
                                     onClick={() => {
                                      openModal(
                                        item?.postInfo?.mediaFilesList?.map(
                                          (file) => file.mediaName
                                        )
                                      );
                                      setSinglePostContent(item);
                                      setSinglePostId(item?.postInfo?.postId);
                                    }}
                                    style={{color:"#00419f"}}
                                   > 
                                     {item?.postInfo?.commentCount} <ChatOutlinedIcon 
                                        style={{color:"#00419f", fontSize: "13px"}}/>
                                     {/* {t("Newsfeed.Comment")} */} 
                                  </p>
                                )}

                                <p className="f-10">
                                  {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                    ? ""
                                    : `&  ${item?.postInfo?.shareCount}`} {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                    ? ""
                                    : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                                     }
                                </p>
                              </div>
                            </div>
                                                   <div className="postengagement">
                                                       <PostEngagement
                                                       setIsLiked={(likedValue) => {
                                                           const currentPostId = item?.postInfo?.postId;
                                                           if (!currentPostId) return;
                                                           setPostLikeState((prev) => ({
                                                               ...prev,
                                                               [String(currentPostId)]: Boolean(likedValue),
                                                           }));
                                                       }}
                                                           isLiked={Boolean(
                                                               postLikeState[String(item?.postInfo?.postId)] ??
                                                                   item?.postInfo?.postActionsInfo?.isLiked
                                                           )}
                                                           item={item}
                                                           postId={item?.postInfo?.postId}
                                                           AllPostList={AllPostList}
                                                           postList={postList}
                                                           setPage={setPage}
                                                           setPostList={setPostList}
                                                           page={page}
                                                           setTotalPages={setTotalPages}
                                                           totalPages={totalPages}
                                                           updateLikeCount={updateLikeCount}
                                                           updateShareCount={updateShareCount}
                                                           openModal={openModal}
                                                           setSinglePostContent={setSinglePostContent}
                                                           setSinglePostId={setSinglePostId}
                                                           ispostmodalOpen={ispostmodalOpen}
                                                           setIspostmodalOpen={setIspostmodalOpen}
                                                           emojiList={emojiList}
                                                           restrictedViewerToken={restrictedViewerToken}
                                                            updatePostLike={updatePostLike}

                                                       />
                                                   </div>
                                                   {console.log("responseData", item)}
                                                   <Comment
                                                       item={item}
                                                       isOwnedPost={item?.postInfo?.isOwned}
                                                       postId={item?.postInfo?.postId}
                                                       AllPostList={AllPostList}
                                                       postList={postList}
                                                       setPage={setPage}
                                                       setPostList={setPostList}
                                                       page={page}
                                                       setTotalPages={setTotalPages}
                                                       totalPages={totalPages}
                                                       emojiList={emojiList}
                                                       updateLikeCount={updateLikeCount}
                                                       updateCommentLike={updateCommentLike}
                                                       updateReplyCommentLike={updateReplyCommentLike}
                                                   />
                                               </div>

                                             </div>
                                            
   
                                           )}
                                       </React.Fragment>
                                   );
                               })}
                           </>
                       )}
                       {/* {postList.length > 6 && hasMoreData ? (''
                       ) : (
                           <p className="text-center">{t("Newsfeed.No more data available")}</p >
                       )} */}
                        {!hasMoreData && postList.length > 6 && (
                        <p className="text-center">{t("Newsfeed.No more data available")}</p>
                        )}
                        {
                           nextBatchLoading && (
                               <div className="text-center">
                                   <img src={post?.loader} width={50} />
                               </div>
                           )
                       }
   
                   </div>
                   <div className="col-md-4 feedAdvertise">
                    <div className="feedfixedContainer">
                        <div className="featuredScroll">
                        {/* <p>Latest code</p> */}
                        <div className="advertisementview">
                            <div
                            className="advertisementContainer"
                            ref={adContainerRef} // Reference to the ad container
                            >
                            {/* The ad will be inserted here */}
                            </div>
                            <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                        </div>
                        <div className="advertisementview">
                            <div
                            className="advertisementContainer"
                            ref={adContainerRef1} // Reference to the ad container
                            >
                            {/* The ad will be inserted here */}
                            </div>
                            <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                        </div>


                        {/* <FeedAdvertise /> */}
                        </div>
                    </div>
                  </div>
            </div>
    
   
   
               {
                   isModalOpen && (
                       <ImageSliderModal
                           isOpen={isModalOpen}
                           setIsLiked={handleModalSetIsLiked}
                           isLiked={modalIsLiked}
                           isLoading={isLoading}
                           setIsLoading={setIsLoading}
                           onRequestClose={closeModal}
                           images={modalImages}
                           item={singlePostContent}
                           singlepostId={singlepostId}
                           setSinglePostId={setSinglePostId}
                           updateShareCount={updateShareCount}
                           updateLikeCount={updateLikeCount}
                           totalPages={totalPages}
                           setTotalPages={setTotalPages}
                           page={page}
                           setPostList={setPostList}
                           setPage={setPage}
                           postList={postList}
                           AllPostList={AllPostList}
                           PostEngagement={PostEngagement}
                           dLike={dLike}
                           updateCommentCount={updateCommentCount}
                           ispostmodalOpen={ispostmodalOpen}
                           setIspostmodalOpen={setIspostmodalOpen}
                           openModal={openModal}
                           setSinglePostContent={setSinglePostContent}
                           setDLike={setDLike}
                           setShowModal={showModal}
                           handleLikesCloseModal={handleLikesCloseModal}
                           isfollowed={isfollowed}
                           setIsfollowed={setIsfollowed}
                           initialSlideIndex={initialSlideIndex}
                           setInitialSlideIndex={setInitialSlideIndex}
                           imageArray={imageArray}
                           restrictedViewerToken={restrictedViewerToken}
                           updateCommentLike={updateCommentLike}
                           updateReplyCommentLike={updateReplyCommentLike}
                           updatePostLike={updatePostLike}

                       />
                   )
               }
               {/* {showModal &&  */}
               <LikesDetails
                   showModal={showModal}
                   handleLikesCloseModal={handleLikesCloseModal}
                   postId={postId}
                   postLikedType={postLikedType}
               />
               {/* } */}
   
   
               {
                   loading && (
                       <div className="row">
                           <div className="col-md-12">
                               <Loading />
                           </div>
                       </div>
                   )
               }
               {
                   showToast && (
                       <SuccessToast
                           show={showToast}
                           message={toastMessage}
                           onClose={() => setShowToast(false)}
                       />
                   )
               }
   
               {
                   showWarningToast && (
                       <WarningToast
                           show={showWarningToast}
                           message={warningToastMessage}
                           onClose={() => setShowWarningToast(false)}
                       />
                   )
               }
               {
                   showErrorToast && (
                       <ErrorToast
                           show={showErrorToast}
                           message={ErrorToastMessage}
                           onClose={() => setShowErrorToast(false)}
                       />
                   )
               }
   </>
  )
}

export default HashTag